import curry from '../core/curry';
import isFunction from '../predicates/isFunction';

const err = 'mapPropNames; First argument must be a function';

/**
 * Given a projection function (fn) and an object (obj)
 * it will each prop names to that function and
 * will return a new object with the transformed prop names
 */

// mapPropNames :: ((a -> b)) -> { x: c } -> { y: c }
function mapPropNames(fn, obj) {
  if (!isFunction(fn)) {
    throw new TypeError(err);
  }

  return Object.entries(obj).reduce((acc, [ key, val ]) => ({ ...acc, ...{ [fn(key)]: val } }), {});
}

export default curry(mapPropNames);
